<template>
    <div class="kgr-row">
        <div class="kgr-inputGroup">
            <div class="kgr-grid kgr-grid--gutters kgr-grid--bigGutters">
                <div class="kgr-grid__cell">
                    <kgr-form-row
                        :label="$t('offering.minage')"
                        :error="error"
                        field-name="minimumAge"
                    >
                        <input
                            v-model.number="offering.minimumAge"
                            type="number"
                            min="0"
                            class="kgr-input"
                            @keyup.enter="onKeyUpEnter"
                        />
                    </kgr-form-row>
                </div>
                <div class="kgr-grid__cell">
                    <kgr-form-row
                        :label="$t('offering.maxage')"
                        :error="error"
                        field-name="maximumAge"
                    >
                        <input
                            v-model.number="offering.maximumAge"
                            type="number"
                            min="0"
                            class="kgr-input"
                            @keyup.enter="onKeyUpEnter"
                        />
                    </kgr-form-row>
                </div>
            </div>
        </div>
        <kgr-form-row
            :label="$t('offering.bookableFor')"
            :error="error"
            field-name="bookableFor"
        >
            <div class="kgr-row kgr-row--bigMargin">
                <kgr-checkbox
                    v-model="offering.bookableForMen"
                    :label="$t('offering.men')"
                    class="kgr-row kgr-row--smallMargin"
                />
                <kgr-checkbox
                    v-model="offering.bookableForWomen"
                    :label="$t('offering.women')"
                />
            </div>
            <div class="kgr-row">
                <kgr-checkbox
                    v-model="offering.bookableForActiveMembers"
                    :label="$t('offering.activeMembers')"
                    class="kgr-row kgr-row--smallMargin"
                />
                <kgr-checkbox
                    v-model="offering.bookableForPassiveMembers"
                    :label="$t('offering.passiveMembers')"
                    class="kgr-row kgr-row--smallMargin"
                />
                <kgr-checkbox
                    v-model="offering.bookableForGuestMembers"
                    :label="$t('offering.guestMembers')"
                    class="kgr-row kgr-row--smallMargin"
                />
            </div>
        </kgr-form-row>
        <div>
            <kgr-form-row
                :label="$t('offering.bookablefordepartments')"
                :error="error"
                field-name="offering.Departments"
            >
                <kgr-multi-select
                    v-model="selectedDepartments"
                    :options="filteredDepartments"
                    select-control-width="50%"
                    :inline="false"
                    searchable
                    @post-input="updateDepartments"
                />
            </kgr-form-row>
            <kgr-form-row
                :label="$t('offering.bookableforteams')"
                :error="error"
                field-name="selectedTeams"
                :inline="false"
            >
                <kgr-multi-select
                    v-model="selectedTeams"
                    :options="filteredTeams"
                    select-control-width="50%"
                    :inline="false"
                    searchable
                    @post-input="updateTeams"
                />
                <kgr-radio
                    v-if="offering.isTraining() && selectedTeams.length"
                    v-model="offering.confirmationType"
                    :options="confirmationTypeOptions"
                    :inline="true"
                />
                <p v-if="offering.confirmationType === Offering.CONFIRMATION_TYPE_ACCEPTANCE_REQUIRED && offering.isTraining() && selectedTeams.length">
                    {{ $t('Die Teammitglieder müssen eigenständig zu den jeweiligen Terminen zu- oder absagen.') }}
                </p>
                <p v-if="offering.confirmationType === Offering.CONFIRMATION_TYPE_DECLINATION_REQUIRED && offering.isTraining() && selectedTeams.length">
                    {{ $t('Für alle Teammitglieder wird die Teilnahme am Training automatisch zugesagt.') }}
                </p>
            </kgr-form-row>
        </div>
    </div>
</template>

<script>
import Checkbox from '../common/form/checkbox/Checkbox.vue';
import DepartmentRepository from '../../js/repository/club/offering/OfferingDepartmentRepository';
import Error from '../../js/model/Error';
import FormRow from '../common/form/FormRow';
import GenericRadio from '../common/form/radio/GenericRadio.vue';
import MultiSelect from '../common/form/select/MultiSelect.vue';
import Offering from '../../js/dto/offering/Offering';
import TeamRepository from '../../js/repository/club/offering/OfferingTeamRepository';

export default {
    name: 'KgrOfferingBookingRequirementsComponent',
    components: {
        'kgr-form-row': FormRow,
        'kgr-multi-select': MultiSelect,
        'kgr-checkbox': Checkbox,
        'kgr-radio': GenericRadio,
    },
    props: {
        clubId: {
            type: Number,
            required: true,
        },
        offering: {
            type: Offering,
            required: true,
        },
        error: {
            type: Error,
            required: true,
        },
    },
    data() {
        return {
            selectedDepartments: [],
            selectedTeams: [],
            departments: [],
            teams: [],
            confirmationTypeOptions: {
                'confirmationType.acceptanceRequired': Offering.CONFIRMATION_TYPE_ACCEPTANCE_REQUIRED,
                'confirmationType.declinationRequired': Offering.CONFIRMATION_TYPE_DECLINATION_REQUIRED,
            },
        }
    },
    computed: {
        Offering() {
            return Offering
        },
        filteredTeams() {
            return this.teams.filter(team => {
                return this.selectedTeams.find(selectedTeam => selectedTeam.value === team.value) === undefined
            });
        },
        filteredDepartments() {
            return this.departments.filter(department => {
                return this.selectedDepartments.find(selectedDepartment => selectedDepartment.value === department.value) === undefined
            });
        }
    },
    created() {
        this.getTeams().then(result => {
            this.teams.length = 0;
            this.teams.push(...result);
        });
        this.getDepartments().then(result => {
            this.departments.length = 0;
            this.departments.push(...result);
        });
        this.selectedDepartments = this.getSelectedDepartment()
        this.selectedTeams = this.getSelectedTeam()
    },
    methods: {
        onKeyUpEnter() {
            this.$emit('enter');
        },
        updateDepartments() {
            this.offering.departments = [];
            this.selectedDepartments.forEach(department => this.offering.departments.push({
                'id': department.value,
                'name': department.label
            }));
        },
        updateTeams() {
            this.offering.teams = [];
            this.selectedTeams.forEach(team => this.offering.teams.push({
                'id': team.value,
                'name': team.label
            }));
            if (this.selectedTeams.length === 0) {
                this.offering.confirmationType = Offering.CONFIRMATION_TYPE_ACCEPTANCE_REQUIRED;
            }
        },
        getSelectedDepartment() {
            const result = [];
            if (this.offering.departments) {
                this.offering.departments.forEach(
                    department => result.push({
                        'label': (department.hierarchyShortPath ? department.hierarchyShortPath + ' / ' : '') + department.name,
                        'value': department.id
                    }
                    )
                );
            }
            return result;
        },
        getSelectedTeam() {
            const result = [];
            if (this.offering.teams) {
                this.offering.teams.forEach(
                    team => result.push({
                        'label': team.name,
                        'value': team.id
                    }
                    )
                );
            }
            return result;
        },
        getDepartments() {
            return DepartmentRepository.findAll(this.clubId)
                .then(departments => {
                    const result = [];
                    departments.sort((a, b) => (a.departmentName + ' / ' + a.name).toLowerCase().localeCompare((b.departmentName + ' / ' + b.name).toLowerCase()));
                    departments.forEach(department => {
                        result.push({
                            'label': department.name,
                            'value': department.id
                        });
                        this.getChildDepartments(department);
                    })
                    return result;
                })
                .catch(() => this.$notify.error('error.loadingData'));
        },
        getChildDepartments(department) {
            department.childDepartments.sort((a, b) => ((a.name).toLowerCase() < (b.name).toLowerCase()) ? -1 : ((a.name).toLowerCase() > (b.name).toLowerCase()) ? 1 : 0);
            department.childDepartments.forEach(childDepartment => {
                this.departments.push({
                    'label': childDepartment.hierarchyPath + ' / ' + childDepartment.name,
                    'value': childDepartment.id
                });
                this.getChildDepartments(childDepartment);
            });
        },
        getDepartment(departmentValue) {
            return this.departments.find(department => department.value === departmentValue);
        },
        getTeams() {
            return TeamRepository.findAll(this.clubId)
                .then(teams => {
                    const result = [];
                    teams.sort((a, b) => ((a.departmentName + ' / ' + a.name).toLowerCase() < (b.departmentName + ' / ' + b.name).toLowerCase()) ? -1 : ((a.departmentName + ' / ' + a.name).toLowerCase() > (b.departmentName + ' / ' + b.name).toLowerCase()) ? 1 : 0);
                    teams.forEach(team => {
                        result.push({
                            'label': team.departmentName + ' / ' + team.name,
                            'value': team.id
                        }
                        );
                    }
                    )

                    return result;
                })
                .catch(() => this.$notify.error('error.loadingData'));
        },
    }
}
</script>
